import { createApp } from 'vue';
import mitt from 'mitt';
import { vMaska } from 'maska/vue';
import InlineSvg from 'vue-inline-svg';
import HeaderMenu from './Components/HeaderMenu.vue';
import Carousel from './Components/Carousel.vue';
import VideoPlayer from './Components/VideoPlayer.vue';
import PracticeAreas from './Components/PracticeAreas.vue';

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
window.gtag = gtag;

const emitter = mitt();

const app = createApp({
    mounted(){
        emitter.emit('mounted');
		(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-K892MS59');
    }
});

app.config.globalProperties.emitter = emitter;
app.component('InlineSvg', InlineSvg);
app.component('HeaderMenu', HeaderMenu);
app.component('Carousel', Carousel);
app.component('VideoPlayer', VideoPlayer);
app.component('PracticeAreas', PracticeAreas);

app.directive('maska', vMaska);

export default app;
